export * from './config.example.js';

export const BACKEND = "https://stu.cs.tsinghua.edu.cn/lab";
export const WS_BACKEND = "wss://stu.cs.tsinghua.edu.cn/lab";
